<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="p-3" dir="ltr">
        <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>
      </div>
      <div class="d-flex m-3 justify-content-between">
        <p class="fw-bold">
          تعریف اقدامات اساسی/ {{$route.params.title}}
        </p>
        <div>
          <div class="d-flex changer">
            <p>
              تعریف اقدامات اساسی
            </p>
            <router-link :to="`/problem_analysis/Definition_of_basic_measures/SupportMeasures/by/${id_route}/${$route.params.title}`">
              تعریف اقدامات پشتیبان
            </router-link>
          </div>
        </div>
      </div>






      <Photographer/>







    </div>
  </div>
</template>


<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import splash from "@/components/Splash/Splash.vue";
import SupportMeasures from "@/components/Definition_of_basic_measures/mother/SupportMeasures.vue";
import Photographer from "@/components/Definition_of_basic_measures/mother/Photographer.vue";
import router from "@/router";

export default {
  components: {
    Photographer,
    SupportMeasures,

    Sidebar,
    splash
  },
  data(){
    return{
      id_route: this.$route['params']['id'],
    }
  },
  methods:{
    checkIsMother(){
      if (!this.is_mother){
        router.push('/')
      }

    }
  },
  mounted() {
    this.checkIsMother()
  }

}
</script>
<style scoped lang="scss">
.changer{
  background-color: #AFAFAF;
  height: 2vw;
  border-radius: 1vw;
  width: 24vw;
  justify-content: space-evenly;
  &>p:nth-child(1){
    width: 11vw;
    height: 2vw;
    background-color: #3742FA;
    color: #fff;
    transform: translateX(.9vw);
    border-radius: 1vw;
  }
  &>p:nth-child(2){
    margin-left: 1vw;
  }  &>p {
       cursor: pointer;
       font-size: 1vw;
     }
  &>a{
    color: black;
    text-decoration: none;
    margin-left: .9vw;
  }
}
p {
  font-size: 1vw;
}
</style>